import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { AppointmentModel } from '../models/appointment';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService extends BaseService {

  listAll(formData: FormData, pStudentID = null, pInstructorID = null) {
    var queryParam = '';

    if(pStudentID)
      queryParam += 'pStudentID=' + pStudentID + '&';

    if(pInstructorID)
      queryParam += 'pInstructorID=' + pInstructorID + '&';

    if(queryParam){
      queryParam = '?' + queryParam.substr(0, queryParam.length - 1)
      return this.httpClient.post<ResultModel<AppointmentModel[]>>(this.getApiUrl(`appointments` + queryParam), formData);
    }
    else{
      return this.httpClient.post<ResultModel<AppointmentModel[]>>(this.getApiUrl(`appointments`), formData);
    }
    
  }

  get(appointmentID: string) {
    return this.httpClient.get<ResultModel<AppointmentModel>>(this.getApiUrl(`appointments/${appointmentID}`));
  }

  create(appointment: AppointmentModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`appointments/add`), appointment);
  }

  update(appointment: AppointmentModel) {
    return this.httpClient.put(this.getApiUrl(`appointments/update`), appointment);
  }

  delete(appointmentID) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`appointments/${appointmentID}`));
  }

  start(appointmentID){
    return this.httpClient.post<ResultModel>(this.getApiUrl(`appointments/start/${appointmentID}`), {});
  }

  finish(appointmentID) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`appointments/finish/${appointmentID}`), {});
  }

  attend(appointmentID) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`appointments/attend/${appointmentID}`), {});
  }

  cancel(appointmentID) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`appointments/cancel/${appointmentID}`), {});
  }



}
